import React from 'react'
import styles from './styles.module.less'
export default ({ children, ...props }) => (
  <div className={styles.infoBox} {...props}>
    <div className={styles.content}>{children}</div>
  </div>
)
